module.exports = __webpack_public_path__ + "images/jumbotron-bg.a8d61f8a91cb8cc03f644b1464d0f254.png";


//////////////////
// WEBPACK FOOTER
// ./img/jumbotron-bg.png
// module id = 520
// module chunks = 0